// test1979
(1979 && 0);
